// extracted by mini-css-extract-plugin
module.exports = {"A_banner":"A_ZA_A_banner__pqob5"};